import styled from 'styled-components';
import { LocalizedParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Icon, IconName, Stack } from '@optimus-web/core';

const Box = styled(Stack)<{ top?: string; right?: string; opacity?: string }>`
    position: absolute;
    top: ${({ top }) => top || 0};
    right: ${({ right }) => right || 0};
    opacity: ${({ opacity }) => opacity || 1};
    border-radius: ${getToken('borderRadius100')}px;
    background: ${getToken('backgroundStaticFlat')};
    padding: ${getSpacingToken('300')}px;
    box-shadow: ${getToken('shadow300')};
`;

const ExternalPayment = () => (
    <Box top="112px" right="165px">
        <Icon value={IconName.ExternalPayment} />
    </Box>
);

const Marketing = () => (
    <Box top="156px" right="-42px" spacing="100">
        <Icon value={IconName.AccountingLedger} />
        <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalInvestInMarketing} />
    </Box>
);

const RoomsRefurbish = () => (
    <Box top="216px" right="-100px" opacity=".8" spacing="100">
        <Icon value={IconName.Bathroom} />
        <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalRefurbishRooms} />
    </Box>
);

const HireEmployees = () => (
    <Box top="269px" right="-86px" opacity=".8" spacing="100">
        <Icon value={IconName.Profile} />
        <LocalizedParagraph textKey={TextKey.FinancialServicesCapitalHireNewEmployees} />
    </Box>
);

export const FundingInvestments = () => (
    <>
        <HireEmployees />
        <RoomsRefurbish />
        <Marketing />
        <ExternalPayment />
    </>
);
